export let baseurl = "https://api.ogcs.co.in";
//  export let baseurl = "http://localhost:5000";
 